import React, { useContext } from "react";
import { useEffect, useState, useRef } from "react";
import "./style.css";
import HarmixService from "../../../services/harmixService";
import { toast } from "react-toastify";
import { ErrorToast, WarningToast } from "../../../pure-components/CustomToast";
import CookieManager from "../../../services/CookieManager";
import { BouncingLoader } from "../../../pure-components/Loader";
import { ReactComponent as ThumbPrintIcon } from '../../../assets/auto_fix_high_black_36dp.svg';
import AddTrackToProjectPopup from "../../Projects/addTrackToProjectPopup";
// import Track from "./track";
import Track from "../../Track";
import { ReactComponent as CloseModal } from "../../../assets/modal-close.svg";
import { useParams, useHistory } from "react-router-dom";

import textFileLogo from "../../../assets/logo/text-file-icon.png";
import spotifyLogo from "../../../assets/logo/spotify-icon.png";
import youtubeLogo from "../../../assets/logo/youtube-icon.png";
import fileUploadLogo from "../../../assets/Upload Icon.png";
import Constants from "../../../services/constants";
import axios from 'axios';
import { ReactComponent as UploadIcon } from '../../../assets/icons/upload_icon.svg';
import { ReactComponent as AIIcon } from '../../../assets/icons/ai-rectangle_icon.svg';
import { ReactComponent as SearchIcon } from '../../../assets/search.svg';

import SegmentSelector from "./segmentSelector";
import MewoService from "../../../services/mewoService";
import defaultImage from "../../../assets/default_music.png";
import { Link } from 'react-router-dom';
import Helper from "../../../services/helper";
import ToggleSwitch from "../../../pure-components/ToggleSwitch/ToggleSwitch";
import UploadIconGIF from "../../../assets/icons/upload_icon.gif"
import uploadIcon from "../../../assets/icons/upload_icon.png";
import API from "../../../services/api";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import HarvestService from "../../../services/harvestService";
import TrackContext from "../../../contexts/track-context";
import Music from "../../Music";
import UploadFileIcon from '@mui/icons-material/Upload';
import { JoinInner } from "@mui/icons-material";
import { Search } from "@material-ui/icons";
import { UploadDocIcon } from "../../NewUI/icons";

const HarmixMusic = (props) => {
  
  const [tags, setTags] = useState(['react', 'tailwind']);
  const [text, setText] = useState('');

  const loadMoreRef = useRef(null);
  const hiddenFileInput = useRef(null);
  const history=useHistory()
  const videoRef = React.createRef();
  const trackContext = useContext(TrackContext);
  const profileData = JSON.parse(CookieManager.getCookie("user-data") || "{}"); 
  const [AISearchPlaceholder, setAISearchPlaceholder] = useState((!profileData || !profileData?.email || profileData?.email?.length === 0)? "Log in to use these functionalities." : "Type your detailed brief (prompt). Or paste a link from YouTube, Spotify, Apple Music, SoundCloud, Vimeo, TikTok. Or upload a reference file in MP3, WAV or AIFF. Or click on the similarity icon of a track.")
  const searchTypes = {
    standard : "Standard",
    prompt : "Prompt"
  }
  const [selectedSearchType, setSelectedSearchType] = useState(searchTypes.standard);
  
  const {
    searchkey,
    setSearchkey,
  } = trackContext;

  const filterType = Constants.SEARCH_TYPE;
  const [searchText,setSearchText] = useState("");
  const pageId = "library";
  const getMusicFilter = () => {
    //if no profile data found, reset the search history to default.
    if(!profileData || !profileData?.email || profileData?.email?.length === 0)
      return { "searchText" : "", "type" : filterType.text};

    return CookieManager.getCookie("harmix-music-filter")?.length > 0 ? JSON.parse(decodeURIComponent(CookieManager.getCookie("harmix-music-filter"))) : { "searchText" : "", "type" : filterType.text};
    
  }
  const [loading, setLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const pageSize = 100;
  const [allDataLoaded, setAllDataLoaded] = useState(true);
  const [loadMore, setLoadMore] = useState(false);
  const [trackList, setTrackList] = useState([]);
  const [musicFilter, setMusicFilter] = useState(getMusicFilter());
  const {assetId}=useParams();

  const [processing, setProcessing] = useState(false);

  const [showProjectModal, setShowProjectModal] = useState(false);
  const [trackToBeAddedToProject, setTrackToBeAddedToProject] = useState("");
  
  const [expandedTrackId, setExpandedTrackId] = useState("");
  
  const [showProgress,setShowProgress]=useState(false);
  const [progress,setProgressValue]=useState(0);
  const [cancelToken,setCancelToken]=useState(); // token for cancel file upload request 
  // const [searchedTrackData, setSearchedTrackDate] = useState(null);

  const [downloadingTracks, setDownloadingTracks] = useState([]);
  const [favingTracks, setFavingTracks] = useState([]);
  const searchedPageSize = 100;
  const [AIMSToken, setAIMSToken] = useState("");
  const [trackHighlightData, setTrackHeighlightData] = useState({});
  
  const location = useLocation();
  const { searchedTrackData } = location.state || {};

  // console.log("searched track data : ", searchedTrackData);
  
  const setDefaultMusicFilter = () => {
    if(!musicFilter){
      setMusicFilter({ "searchText" : "", "type" : filterType.text});
      CookieManager.setCookie("harmix-music-filter", encodeURIComponent(JSON.stringify({ "searchText" : "", "type" : filterType.text})));
    }
  } 

  const setMusicFilterData = (filter) => {
    // console.log("setting filter : ", filter)
    if(filter){
      setMusicFilter(filter);
      CookieManager.setCookie("harmix-music-filter", encodeURIComponent(JSON.stringify(filter)));
    }
  } 

  useEffect(() => {
    const filter = getMusicFilter();

    if(selectedSearchType === searchTypes.standard)
      return;
    //if assetId and filter data not matching
    //setting page default  
    if(filter?.type === filterType.track && assetId !== filter?.searchRef){
      setMusicFilter({ "searchText" : "", "type" : filterType.text})
      CookieManager.setCookie("harmix-music-filter", encodeURIComponent(JSON.stringify({ "searchText" : "", "type" : filterType.text})));
      history.push("/library");
      return;
    }else{
      setMusicFilter(filter);
      (async() => {
        await loadAIMSTrackList(filter, true);
      })();
    }
    
    
  }, [assetId]);

  
  useEffect(() => {
    if(musicFilter?.type !== "video_file"){
      if(selectedSearchType === searchTypes.prompt)
        (async() => {
          // console.log("empty useEffect");
          await loadTrackList(getFilterObj());
        })()
    }else{
      const filterObj = {
        "video_reference": {
          "upload_id": musicFilter.searchRef
        }
      };
      (async() => {
        await loadHarmixTrackList(filterObj, true);
      })()
    }
    
  }, [])

  useEffect(() => {
    if(musicFilter.type === filterType.text || musicFilter.type === filterType.youtube || musicFilter.type === filterType.spotify)
      setSearchText(musicFilter.searchText);
    // console.log("useEffect MF: ", musicFilter)
  }, [musicFilter])

    
  useEffect(() => {
    // console.log(pageNo)
  }, [pageNo])

  useEffect(() => {
    if(loadMore)
      (async() => {
        await loadTrackList(getFilterObj());
      })()
    
  }, [loadMore])

  // useEffect(() => {
  //   if(musicFilter){
  //     let filter = {};
  //     switch(musicFilter.type){
  //       case "text": filter = {"prompt" : musicFilter.searchText};
  //       break;
  //       case "youtube":
  //       case "spotify":
  //       case "file": 
  //         if(musicFilter.searchRef)
  //           filter = {
  //               "audio_reference": {
  //               "external": {
  //                   "upload_id": musicFilter.searchRef
  //               }
  //             }
  //           }
  //       break;

  //     }
  //     if((musicFilter.type==='text' && !loading) || (musicFilter.type !== 'text' && musicFilter.searchRef))
  //       (async() => {
  //         await loadTrackList(filter, true);
  //       })();
  //   }
  // }, [musicFilter]);

  const getTrackInfo = async(trackIds, initial = false) => {
      if(!trackIds?.length){
        console.error("Track Ref not found to load track data.");
        setLoading(false);
        return;
      }
      setLoading(true);
      const filter = {
        "ReturnAlternateVersions":"false",
        "ReturnAttributes":"true",
        "ReturnCategories":"false",
        "ReturnCategoryFacet":"false",
        "ReturnCodes":"false",
        "ReturnComposers":"true",
        "ReturnRelatedTracks":"false",
        "ReturnRightHolders":"false",
        "GetMainVersionFromAlternate":"false",
        "CuesheetOnlyCodesAndAttribute":"false",
        "ReturnInactiveTracks":"false",
        "ReturnRegionOnlyTracks":"false",
        "Offset":"0",
        "Limit":searchedPageSize,
        "track":trackIds
      }
      const reqObj = {
        refUrl : `/gettracks/{memberToken}`, 
        method : 'post',
        headers : {
            "Accept" : "application/json",
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
        },
        data : JSON.stringify(filter)
      };
      await HarvestService.loadHarvestData(reqObj).then((resp) => {
        // console.log("Track Data : ", resp);
        if(!resp?.Tracks || resp?.Tracks?.length === 0){
          toast(({ closeToast }) => <WarningToast  message={"No tracks found for searched query."}/>);
        }else{
          if(initial){
            setTrackList([...resp.Tracks]);
          }else{
            setTrackList([...trackList, ...resp.Tracks]);
          }
        }
      }).catch((err) => {
        console.error("Track Data Loading Error : ", err);
      }).finally(() =>{
        setAllDataLoaded(true);
        setLoading(false);

      })
      
  }


  const getHarvestFilterObj = (filter = null) => {
    if(filter === null)
      filter = {...musicFilter};
    if(filter){
      let tempfilter = null;
      switch(filter.type){
        case filterType.text: tempfilter = {"prompt" : filter.searchText};
        break;
        case filterType.youtube:
        case filterType.spotify:
        case filterType.audio_file: 
          if(filter.searchRef)
            tempfilter = {
                "audio_reference": {
                "external": {
                    "upload_id": filter.searchRef
                }
              }
            }
        break;
        case filterType.video_file: 
          if(filter.searchRef)
            tempfilter = {
                "video_reference": {
                  "upload_id": filter.searchRef
                }
              }
        break;

        case filterType.track: 
          if(filter.searchRef)
            tempfilter = {
              "audio_reference": {
                "internal": {
                  "primary_key": {
                      "source_id": filter.searchRef,
                      // "version_tag": "<version_tag>",
                      // "vocal": true
                  }
                }
              }
            }
          if(filter.segment)
            tempfilter.audio_reference.segment = getselectedSegment(filter);
          tempfilter.audio_reference.ignore_vocals = filter.ignore_vocals || false;
          tempfilter.audio_reference.prioritize_bpm = filter.prioritize_bpm || false;
        break;

        default : 
        break;
      }
      return tempfilter;
    }
  }

  const getFilterObj = (filter = null) => {
    if(filter === null)
      filter = {...musicFilter};
    if(filter){
      let tempfilter = null;
      switch(filter.type){
        case filterType.text: 
          tempfilter = {
            "SearchFilters": {
              "SearchType": "Normal",
              "IncludeInactive": "false",
              "MainOnly": "true",
              "SearchTermBundle": {
                  "St_Audio": {
                      "Audio": [
                          {
                              "Prompt": filter.searchText || Helper.getRandomMusicKey()
                          }
                      ],
                      "Start": "",
                      "Duration": ""
                  }
              },
              "ResultView": { 
                  "View": "Track",
                  "Sort_Predefined": "EvokeRanking",
                  "Evoke_PrioritizeBPM": false,
                  "Evoke_SuppressVocals": false,
                  "Skip": "0",
                  "Limit": searchedPageSize,
                  include_lyrics : true
              }
            }
          };
        break;
        case filterType.youtube:
        case filterType.spotify:
        case filterType.vimeo:
        case filterType.tiktok:
        case filterType.apple_music:
        case filterType.sound_cloud:  
          tempfilter =  {
            "SearchFilters": {
              "SearchType": "Normal",
              "IncludeInactive": "false",
              "MainOnly": "true",
                "SearchTermBundle": {
                    "St_Audio": {
                        "Audio":[{
                          "Url": filter.searchText,
                          "Type": filter.type,
                          "Start": "",
                          "Duration": ""
                        }]
                    }
                },
                "ResultView": {
                    "View": "Track",
                    "Sort_Predefined": "EvokeRanking",
                    "Evoke_PrioritizeBPM": false,
                    "Evoke_SuppressVocals": false,
                    "Limit": searchedPageSize,
                    include_lyrics : true
                }
            }
          }
        break;
        // case filterType.audio_file: 
        //   if(filter.searchRef)
        //     tempfilter = {
        //       "SearchFilters": {
        //         "SearchTermBundle": {
        //             "St_Audio": {
        //                 "Audio":[{"TrackID": filter.searchRef}],
        //                 "Start": "",
        //                 "Duration": ""
        //             }
        //         },
        //         "ResultView": {
        //             "Sort_Predefined": "EvokeRanking",
        //             "Evoke_IncludeSeed": false,
        //             "Evoke_PrioritizeBPM": false,
        //             "Evoke_SuppressVocals": false,
        //             "Limit": searchedPageSize
        //         }
        //       }
        //     }
        // break;
        
        case filterType.track: 
          if(filter.searchRef)
            tempfilter = {
              "SearchFilters": {
                  "SearchType": "Normal",
                  "IncludeInactive": "false",
                  "MainOnly": "true",
                  "SearchTermBundle": {
                      "St_Audio": {
                          "Audio":[{"TrackID": filter.searchRef}],
                          "Start": "",
                          "Duration": ""
                      }
                  },
                  "ResultView": {
                      "View": "Track",
                      "Sort_Predefined": "EvokeRanking",
                      "Evoke_IncludeSeed": false,
                      "Evoke_PrioritizeBPM": false,
                      "Evoke_SuppressVocals": false,
                      "Limit": searchedPageSize,
                      include_lyrics : true
                  }
                }
            }
          if(filter.segment){
            const {start, end} = getselectedSegment(filter);
            tempfilter.SearchFilters.SearchTermBundle.St_Audio.Start = start;
            tempfilter.SearchFilters.SearchTermBundle.St_Audio.Duration = end - start;
          }
          tempfilter.SearchFilters.ResultView.Evoke_SuppressVocals = filter.ignore_vocals || false;
          tempfilter.SearchFilters.ResultView.Evoke_PrioritizeBPM = filter.prioritize_bpm || false;
          
        break;

        default : 
        break;
      }
      return tempfilter;
    }
  }

  const getAIMSQueryObj = (filter = null) => {
    if(filter === null)
      filter = {...musicFilter};
    if(filter){
      let query = null;
      switch(filter.type){
        case filterType.text: 
          query = {
            "url": "/by-text",
            data : {
              "text" : filter.searchText || Helper.getRandomMusicKey(), 
              "page": pageNo,
              "page_size": searchedPageSize,
              "highlights" : true
            }
          };
        break;
        case filterType.youtube:
        case filterType.spotify:
        case filterType.vimeo:
        case filterType.tiktok:
        case filterType.apple_music:
        case filterType.sound_cloud:  
          query = {
            "url": "/by-url",
            data : {
              "link" : filter.searchText, 
              "page": pageNo,
              "page_size": searchedPageSize,
              "highlights" : true
            }
          };
        break;
        // case filterType.audio_file: 
        //   if(filter.searchRef)
        //     tempfilter = {
        //       "SearchFilters": {
        //         "SearchTermBundle": {
        //             "St_Audio": {
        //                 "Audio":[{"TrackID": filter.searchRef}],
        //                 "Start": "",
        //                 "Duration": ""
        //             }
        //         },
        //         "ResultView": {
        //             "Sort_Predefined": "EvokeRanking",
        //             "Evoke_IncludeSeed": false,
        //             "Evoke_PrioritizeBPM": false,
        //             "Evoke_SuppressVocals": false,
        //             "Limit": searchedPageSize
        //         }
        //       }
        //     }
        // break;
        
        case filterType.track: 
          if(filter.searchRef)
            query = {
              "url": "/by-id",
              data : {
                "track_id" : filter.searchRef, 
                "input_id_type": "client",
                "page": pageNo,
                "page_size": searchedPageSize,
                "highlights" : true
              }
            };
          if(filter.segment){
            const {start, end} = getselectedSegment(filter);
            query.data.time_offset = start;
            query.data.time_limit = end - start;
          }
          query.data.suppress_vocals = filter.ignore_vocals || false;
          query.data.prioritise_bpm = filter.prioritize_bpm || false;
          
        break;

        default : 
        break;
      }
      return query;
    }
  }


  // useEffect(() => {

  // }, [trackList])

  const getselectedSegment = (filterObj) => {

    if(filterObj?.segment && filterObj.segment?.start && filterObj.segment?.end){
      return {start : parseInt(filterObj.segment?.start), end : parseInt(filterObj.segment?.end) }
    }
    return {start : 0, end : parseInt(searchedTrackData.duration)}
  }
  const loadTrackListOld = async(filter, initial = false) => {
    if(!filter){
      console.log("No filter found to load the track list");
      return;
    }
    setLoading(true);
    // console.log("page no : ", pageNo)
    let offset = pageNo*pageSize;
    if(initial){
      setPageNo(0);
      offset = 0;
      setTrackList([])
      setAllDataLoaded(false);
    }
    let reqObj = {
      url : `search?offset=${offset}&limit=${pageSize}`,
      method : 'post',
      data: JSON.stringify( filter )
    };
    await HarmixService.executeRequest(reqObj).then((resp) => {
      // console.log("response data : ", resp)
      let tempDataList = pageNo > 0 ? [...trackList] : [];
      if(initial)
        tempDataList = [];

      if(resp?.tracks?.length > 0)
        tempDataList.push(...resp?.tracks)

      
      if(resp?.tracks?.length < pageSize || resp.tracks_number < pageSize){
        setAllDataLoaded(true);
      }else{
        setAllDataLoaded(false);
        setPageNo(pageNo + 1);
      }

      setTrackList(tempDataList);
      // console.log("track list : ", trackList);
    }).catch((err) => {
      console.log("Track List Loading Error : ", err);
      //Modify the error handling when array returned as error
      toast(({ closeToast }) => <ErrorToast  message={err?.detail?.message ? `${err.detail.code} : ${err.detail.message}` : `${err.detail}`}/>);
      setAllDataLoaded(true);
    });
    setLoadMore(false)
    setLoading(false);
  }

  const loadTrackList = async(filter, initial = false) => {
    if(!filter){
      console.log("No filter found to load the track list");
      return;
    }
    setLoading(true);
    // console.log("page no : ", pageNo)
    let offset = pageNo*pageSize;
    if(initial){
      setPageNo(0);
      offset = 0;
      setTrackList([])
      setAllDataLoaded(false);
    }
    
    const reqObj = {
      refUrl : `/cloudsearch/{memberToken}`, 
      method : 'post',
      headers : {
          "Accept" : "application/json",
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
      },
      data : JSON.stringify(filter)
    };
    await HarvestService.loadHarvestData(reqObj).then((resp) => {
      // console.log("response data : ", resp)
      let tempDataList = pageNo > 0 ? [...trackList] : [];
      if(initial)
        tempDataList = [];

      if(resp?.Tracks?.length > 0)
        tempDataList.push(...resp?.Tracks)

      if(!resp?.Tracks || resp?.Tracks?.length === 0){
        toast(({ closeToast }) => <WarningToast  message={"No tracks found for searched query."}/>);
        setAllDataLoaded(true);
        return;
      }
      if(resp?.Tracks?.length < searchedPageSize){
        setAllDataLoaded(true);
      }else{
        setAllDataLoaded(false);
        setPageNo(pageNo + 1);
      }

      setTrackList(tempDataList);
      // console.log("track list : ", trackList);
    }).catch((err) => {
      console.log("Track List Loading Error : ", err);
      //Modify the error handling when array returned as error
      toast(({ closeToast }) => <ErrorToast  message={"Searched track list loading error."}/>);
      setAllDataLoaded(true);
    });
    setLoadMore(false)
    setLoading(false);
  }

  const loadAIMSTrackList = async(filter, initial = false) => {
    if(!filter){
      console.log("No filter found to load the track list");
      return;
    }
    setLoading(true);
    // console.log("page no : ", pageNo)
    let offset = pageNo*pageSize;
    if(initial){
      setPageNo(1);
      offset = 0;
      setTrackList([])
      setAllDataLoaded(false);
    }

    const reqObj = {
      method : "POST"
    };
    const queryObj = getAIMSQueryObj(filter);
    
    reqObj.url = queryObj.url;
    reqObj.data = queryObj.data;
    
   
    await API.loadAIMSTrackList(reqObj).then(async(resp) => {
      // console.log("response data : ", resp)
      let trackIds = [];
      let tempHighlights = {};
      if(resp.data?.tracks?.length > 0)
        resp.data.tracks.forEach(elem => {
          if(elem?.id_client?.length > 0){
            trackIds.push(elem.id_client);
            tempHighlights[elem.id_client] = elem.highlights;
          }
        })

      if(trackIds?.length > 0){
        setTrackHeighlightData(tempHighlights);
        await getTrackInfo(trackIds, initial);
      }
      
    }).catch((err) => {
      console.log("Track List Loading Error : ", err);
      //Modify the error handling when array returned as error
      toast(({ closeToast }) => <ErrorToast  message={"Searched track list loading error."}/>);
      setAllDataLoaded(true);
    });
    setLoadMore(false)
    setLoading(false);
  }

  const getFilter = () => {
    //store filters with types/category in local storage, add them as needed
    //track all filter separatly, 
    //like audio/video upload search, prompt, youtube/spotify link search
    //pagination should follow the searh_id returned in response [need to discuss to Harmix]
    //if want to keep tags search from MEWO, maintain it separatly.

    
    //default filter as nothing in prompt

    //checking for link
    if(searchText && searchText.indexOf('https://') !== -1){
      //youtube/spotify link, search like that

    }else if(searchText?.length > 0){
      //prompt search 
      return {
        "prompt" : searchText
      }  
    }else{
      //default filter
      return {
        "prompt" : ""
      }
    }
  }



  const handleSearch = async(e) => {
    
    // searchText = setSearchText(searchText + e.target.value)
    if(e.key === 'Enter' && !loading){
      // console.log(e.key, searchText);
      //resetting routes
      history.push("/library");
      setPageNo(1);
      setTrackList([])
      if(searchText?.indexOf('https://') !== -1){
        //youtube/spotify/... link
        const filterData = {
          type : getFilterTypeFromURL(searchText),
          searchText : searchText
        };
        
        setMusicFilterData(filterData);
        await loadAIMSTrackList(filterData, true);
      }else{
        const tempFilter = {
          type : filterType.text,
          searchText : searchText
        };
        setMusicFilterData(tempFilter);
        await loadAIMSTrackList(tempFilter, true);
      }
    }
  };

  const getFilterTypeFromURL = (url)=>{
    
    switch(true) {
      case (url.indexOf('youtube') > -1) : 
        return filterType.youtube;
      
      case (url.indexOf('spotify') > -1) : 
        return filterType.spotify;
      
      case (url.indexOf('tiktok') > -1) : 
        return filterType.tiktok;

      case (url.indexOf('vimeo') > -1) : 
        return filterType.vimeo;

      case (url.indexOf('music.apple.com') > -1) : 
        return filterType.apple_music;
      
      case (url.indexOf('soundcloud') > -1) : 
        return filterType.sound_cloud;
      
      default : 
        return filterType.text;

    }
  }
  const handleSearchClick = async() => {
    
    if(!loading){
      //resetting routes
      history.push("/library");
      setPageNo(0);
      setTrackList([])
      if(searchText?.indexOf('https://') !== -1){
        //youtube/spotify link, search via upload
        await searchViaUpload(searchText);
      }else{
        setMusicFilterData({"searchText" : searchText, type : filterType.text});
        await loadTrackList({"prompt" : searchText}, true);
      }
    }
  };

  const handleUploadClick = async (event) => {
    if (!trackContext.validateUser(Constants.ACTION.SEARCH)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.SEARCH);
      return;
    }
    hiddenFileInput.current.value=null;
    hiddenFileInput.current.click();
    // await loadAIMSAuthToken();
  };

  const loadAIMSAuthToken = async () => {
    
    await API.loadAIMSTokenData().then(async(resp) => {
      // console.log("auth token response data : ", resp)
      setAIMSToken(resp.data);
      
    }).catch((err) => {
      console.log("AIMS Auth Token Loading Error : ", err);
      //Modify the error handling when array returned as error
      toast(({ closeToast }) => <ErrorToast  message={"AIMS Auth Token Loading Error."}/>);
    });
  }

  const searchAIMSViaFileUpload = async (file) => {
    if(!(AIMSToken?.length > 0)){
      toast(({ closeToast }) => <ErrorToast  message={"File Processing Error, try uploading again."}/>);
      return;
    }
    let filterData = {};
    filterData["type"] = filterType.audio_file;
    filterData["searchText"] = file.name;
    setMusicFilterData(filterData);

    setShowProgress(true);
    setProgressValue(0);
    setProcessing(true);
    // console.log("page no : ", pageNo)
    
    setPageNo(1);
    setTrackList([])
    setAllDataLoaded(false);
  
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    setCancelToken(source);

    const onUploadProgress = (event) => {
      setShowProgress(true);
      let progress = Math.round((100 * event.loaded) / event.total);
      setProgressValue(progress);
    }

    let formData=new FormData();
    formData.append('track',file);
    formData.append("page", 1);
    formData.append("page_size", searchedPageSize);
    formData.append("highlights", true);
    
    let req = {
      url: "https://api.aimsapi.com/v1/query/by-file",
      method: "post",
      headers: {
          "Content-Type": "multipart/form-data",
          "X-Requested-With" : "XMLHttpRequest",
          "X-token": AIMSToken
        },
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
      data : formData
    };
    if(onUploadProgress)
      req = {...req, onUploadProgress};
    if(source?.token)
      req.cancelToken = source.token;
    let response = await axios(req).then((res) => {
      return res;
    }).catch(err => {
      if (axios.isCancel(err)) {
        console.log("AIMS audio file search upload cancelled.");
        setCancelToken();
        setShowProgress(false);
        setProcessing(false);
      }else
        console.error("AIMS Audio File search error : ", err);
    })
    .finally(() => {
      setShowProgress(false);
      setProcessing(false);
      setLoadMore(false);
    });
    // console.log("response data : ", response);
    
    let trackIds = [];
    let tempHighlights = {};
    if(response?.data?.tracks?.length > 0)
      response.data.tracks.forEach(elem => {
        if(elem?.id_client?.length > 0){
          trackIds.push(elem.id_client);
          tempHighlights[elem.id_client] = elem.highlights;
        }
      })

    if(trackIds?.length > 0){
      setTrackHeighlightData(tempHighlights);
      await getTrackInfo(trackIds, true);
    }

    
  }

  const uploadAudioFile=async(file)=>{
    setSearchText("");
    if (!file) {
      toast(({ closeToast }) => <WarningToast  message={"Please select a file first!"}/>);
      return;
    }
    if(file){
      //resetting routes
      history.push("/library");
      
      let data=new FormData();
      data.append('file',file);
      if(file.type.indexOf("video") > -1){
        const videoURL = URL.createObjectURL(file);
        document.getElementById("video-player").setAttribute("src", videoURL);
        let filterData = {};
        filterData["type"] = filterType.video_file;
        filterData["searchText"] = file.name;
        setMusicFilterData(filterData);
      }else{
        let filterData = {};
        filterData["type"] = filterType.audio_file;
        filterData["searchText"] = file.name;
        setMusicFilterData(filterData);
        await searchViaUpload(file);
      }
    }else{
      console.log("File processing error");
    }
  } 

  const searchViaUpload = async(file) => {
    try{
      setProcessing(true);
      setTrackList([]);
      const uploadURLData = await API.getUploadFileURL(file.name)
        .catch((err) => {
          console.log("Error generating File Upload URL : ", err);
          toast(({ closeToast }) => <ErrorToast  message={"Error generating File Upload URL."}/>);
        })
      // console.log("uplaod response : ", uploadURLData);
      if(uploadURLData?.success){
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        setCancelToken(source);

        const onUploadProgress = (event) => {
          setShowProgress(true);
          let progress = Math.round((100 * event.loaded) / event.total);
          setProgressValue(progress);
        }

        let tempReqObj = {
          method: "put",
          url: uploadURLData.data.PresignedUploadUrl,
          headers: {
            "Content-Type": "audio/mpeg",
          },
          data : file,
          maxContentLength: Infinity,
          maxBodyLength: Infinity,
        }
        if(onUploadProgress)
          tempReqObj = {...tempReqObj, onUploadProgress};
        if(source?.token)
          tempReqObj.cancelToken = source.token;

        const uploadResp = await axios(tempReqObj)
          .catch(err => {
            if (axios.isCancel(err)) {
              // console.log("File Upload cancelled.");
              setCancelToken();
              setShowProgress(false);
            }else
              console.error("File uplaod error : ", err);
          });

        setProcessing(false);
        
        if (uploadResp.statusText === "OK") {
          console.log("✅ File uploaded successfully!");
          setShowProgress(false);
          setLoading(true);

          const tempFilter = getMusicFilter();
          setMusicFilterData({...tempFilter, searchRef : uploadURLData.data.ResourceUrl});

          const searchResp = await API.loadSearchedDataUsingUpload({fileName : file.name, url : uploadURLData.data.ResourceUrl})
            .catch((err) => {
              console.log("Error searching tracks via File Upload : ", err);
              toast(({ closeToast }) => <ErrorToast  message={"Error searching tracks via File Upload. Please try uploading again."}/>);
            })
          // console.log("search resp : ", searchResp);
          setLoading(false);
          if(searchResp?.data?.Tracks?.length > 0){
            setTrackList([...searchResp.data.Tracks]);
            return;
          }
          if(!searchResp?.data?.Tracks || searchResp?.data?.Tracks?.length === 0){
            toast(({ closeToast }) => <WarningToast  message={"No tracks found for uploaded track."}/>);
            setAllDataLoaded(true);
            setTrackList([]);
            return;
          }
        } else {
          console.error("❌ Upload failed. Error : ", uploadResp);
        }
      }else{
        console.log("Error generating File Upload URL : ", uploadURLData);
        toast(({ closeToast }) => <ErrorToast  message={"Error generating File Upload URL."}/>);
      }
    }catch(err) {
      console.log("File upload search error : ", err);
    }finally{
      setProcessing(false);
      setCancelToken();
      setShowProgress(false);
    }
  }

  const loadHarmixTrackList = async(filter, initial = false) => {
    if(!filter){
      console.log("No filter found to load the harmix track list");
      return;
    }
    setLoading(true);
    // console.log("page no : ", pageNo)
    let offset = pageNo*pageSize;
    if(initial){
      setPageNo(0);
      offset = 0;
      setTrackList([])
      setAllDataLoaded(false);
    }
    let reqObj = {
      url : `search?offset=${offset}&limit=${pageSize}`,
      method : 'post',
      data: JSON.stringify( filter )
    };
    await HarmixService.executeRequest(reqObj).then(async(resp) => {
      // console.log("response data : ", resp)
      let trackIds = [];
      if(resp?.tracks?.length > 0)
        resp.tracks.forEach(elem => {
          if(elem?.metadata?.source_id?.length > 0)
            trackIds.push(elem.metadata.source_id)
        })

      if(trackIds?.length > 0){
        await getTrackInfo(trackIds);
      }
      
    }).catch((err) => {
      console.log("Track List Loading Error : ", err);
      //Modify the error handling when array returned as error
      toast(({ closeToast }) => <ErrorToast  message={err?.detail?.message ? `${err.detail.code} : ${err.detail.message}` : `${err.detail}`}/>);
      setAllDataLoaded(true);
    });
    setLoadMore(false)
    setLoading(false);
  }

  const searchViaVideoUpload = async(fileData = null) => {
    setProcessing(true);
    let data = new FormData();
    let source;
    
    const snapshots = await createSnapshots(0, videoRef);
    // console.log("Generated Snapshots:", snapshots);
    snapshots.forEach((fileData) => data.append("source", fileData));
    data.append("type", "manual-video");
      
    const CancelToken = axios.CancelToken;
    source = CancelToken.source();
    setCancelToken(source);

    let reqObj = {
      url : `upload`,
      method : 'post',
      data: data
    };
    await HarmixService.executeRequest(reqObj, source ? (event) => {
      setShowProgress(true);
      let progress = Math.round((100 * event.loaded) / event.total);
      setProgressValue(progress);
    } : null,source ? source : null).then(async(resp) => {
      // console.log("uploaded response data : ", resp)
      if(resp.status === "success"){
        console.log("✅ Video File uploaded successfully!");
        setShowProgress(false);
        setLoading(true);
         
        const tempFilter = getMusicFilter();
        setMusicFilterData({...tempFilter, searchRef : resp.upload_id});

        const filterObj = {
          "video_reference": {
            "upload_id": resp.upload_id
          }
        }
        await loadHarmixTrackList(filterObj, true);
      }else{
        console.log("Something wrong with uploading reference track data : ", resp)
      }
    }).catch((err) => {
      console.log("Track reference upload Error : ", err);
      //Modify the error handling when array returned as error
      if(err.message !== Constants.FILE_UPLOAD_CANCELLED)
        toast(({ closeToast }) => <ErrorToast  message={err?.detail?.message ? `${err.detail.code} : ${err.detail.message}` : `${err.detail}`}/>);
    });
    setProcessing(false);
    setLoadMore(false)
    setLoading(false);
    
    setCancelToken();
    setShowProgress(false);
  }

  const searchViaUploadOld = async(url = "", fileData = null) => {
    setProcessing(true);
    let data = new FormData();
    let source;
    //youtube/spotify URL
    if(url?.length > 0){
      let filterData = {};

      if(url.indexOf('youtube') > -1){
        data.append("type", "youtube-audio");
        filterData["type"] = filterType.youtube; 
      }else{
        data.append("type", "spotify");
        filterData["type"] = filterType.spotify;
      }
      data.append("reference", url)
      filterData["searchText"] = url;
      
      setMusicFilterData(filterData);
    }else{
      // TODO : segrigate payload logic for audio or video upload
      if(fileData?.type?.indexOf("video") > -1){
        let duration;
        const videoURL = URL.createObjectURL(fileData);
        // var video = document.getElementById('video-player');
        // video.preload = 'metadata';
        // video.src = URL.createObjectURL(fileData);
        
        // video.onloadedmetadata = function() {
        //   window.URL.revokeObjectURL(video.src);
        //   duration = video.duration;
        // }

        // // video.src = URL.createObjectURL(fileData);
        // URL.revokeObjectURL(video.src);

        // $("#video-player").prop("src", videoURL);
        document.getElementById("video-player").setAttribute("src", videoURL);
        duration = document.getElementById("video-player").duration;
        //videoRef.current.src = videoURL;
        //URL.revokeObjectURL(videoRef.current.src);
        const videoElement = videoRef.current;
        if (!videoElement) {
          console.error("Video is not available.");
          return;
        }
        const snapshots = await createSnapshots(duration, document.getElementById("video-player"));
        console.log("Generated Snapshots:", snapshots);
        snapshots.forEach((fileData) => data.append("source", fileData));
        data.append("type", "manual-video");
      }else{
        data.append("type", "manual-audio");
        data.append("source", fileData);
      }
      if(fileData){
        data.append("type", "manual-audio");
        data.append("source", fileData);
      }else{
        const snapshots = await createSnapshots(0, videoRef);
        // console.log("Generated Snapshots:", snapshots);
        snapshots.forEach((fileData) => data.append("source", fileData));
        data.append("type", "manual-video");
      }
      
      const CancelToken = axios.CancelToken;
      source = CancelToken.source();
      setCancelToken(source);
    
    }

    let reqObj = {
      url : `upload`,
      method : 'post',
      data: data
    };
    await HarmixService.executeRequest(reqObj, source ? (event) => {
      setShowProgress(true);
      let progress = Math.round((100 * event.loaded) / event.total);
      setProgressValue(progress);
    } : null,source ? source : null).then(async(resp) => {
      // console.log("uploaded response data : ", resp)
      if(resp.status === "success"){
        // const filterObj = {
        //   "audio_reference": {
        //     "external": {
        //         "upload_id": resp.upload_id
        //     }
        //   }
        // }
        setPageNo(0);
        setTrackList([])
        setProcessing(false);
        const tempFilter = getMusicFilter();
        // console.log("music filter : ", tempFilter)
        setMusicFilterData({...tempFilter, searchRef : resp.upload_id});

        await loadTrackList(getFilterObj({...tempFilter, searchRef : resp.upload_id}), true);
      }else{
        console.log("Something wrong with uploading reference track data : ", resp)
      }
    }).catch((err) => {
      console.log("Track reference upload Error : ", err);
      //Modify the error handling when array returned as error
      if(err.message !== Constants.FILE_UPLOAD_CANCELLED)
        toast(({ closeToast }) => <ErrorToast  message={err?.detail?.message ? `${err.detail.code} : ${err.detail.message}` : `${err.detail}`}/>);
    });
    setProcessing(false);
    setLoadMore(false)
    setLoading(false);
    
    setCancelToken();
    setShowProgress(false);
  }
  useEffect(() => {
    const sentinel = loadMoreRef.current;

    if (!sentinel || allDataLoaded || loading || processing) {
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setLoadMore(true);
      }
    }, {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    });

    observer.observe(sentinel);

    return () => observer.disconnect();
  }, [allDataLoaded, loading, processing, trackList.length]);


  const createSnapshots = async (duration, player) => {
    // $("#video-player").on("canplaythrough", function(e){
    //   duration = e.currentTarget.duration;
    // });
    duration = document.getElementById(
      "video-player").duration;
    const video = player.current;
    const videoElement = document.getElementById("video-player");
    // console.log("video element : ". player, duration, videoElement.metadata, videoElement.getAttribute("duration"))
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (!context) {
      console.error("Canvas context is not available.");
      return [];
    }

    const times = [5, duration * 0.25, duration * 0.5, duration * 0.75, duration - 5];
    const newSnapshots = [];

    for (const time of times) {
      video.currentTime = time;

      await new Promise((resolve) => {
        video.onseeked = async () => {
          try {
            const targetWidth = 226;
            const targetHeight = 226;

            const tempCanvas = document.createElement("canvas");
            const tempContext = tempCanvas.getContext("2d");

            if (!tempContext) {
              console.error("Temporary canvas context is not available.");
              resolve();
              return;
            }

            tempCanvas.width = targetWidth;
            tempCanvas.height = targetHeight;
            tempContext.drawImage(video, 0, 0, targetWidth, targetHeight);

            tempCanvas.toBlob(
              (blob) => {
                if (blob) {
                  const snapshotFile = new File([blob], `snapshot_${time}.jpeg`, {
                    type: "image/jpeg",
                  });
                  newSnapshots.push(snapshotFile);
                } else {
                  console.error("Failed to convert canvas to blob.");
                }
                resolve();
              },
              "image/jpeg",
              1.0
            );
          } catch (error) {
            console.error(`Error generating snapshot for time ${time}:`, error);
            resolve();
          }
        };
      });
    }

    return newSnapshots;
  };
  
  const displayProjectModal = (trackId) => {
    setTrackToBeAddedToProject(trackId);
    setShowProjectModal(true);
  };

  const closeProjectModal = () => {
    setShowProjectModal(false);
  };

  const removeSearchFilter = (type) => {
    let tempFilter = {...musicFilter}
    switch(type){
      case filterType.text : 
        tempFilter = {...musicFilter, "searchText" : "", "type" : filterType.text};
        setSearchText("");
        break;
      case filterType.youtube:
        setSearchText("");
        tempFilter = {...musicFilter, "searchText" : "", "type" : filterType.text, "searchRef" : ""};
        break;
      case filterType.spotify:
        setSearchText("");
        tempFilter = {...musicFilter, "searchText" : "", "type" : filterType.text, "searchRef" : ""};
        break;
      case "file":
      case filterType.audio_file:
      case filterType.video_file:
        tempFilter = {...musicFilter, "searchText" : "", "type" : filterType.text, "searchRef" : ""};
        break;
      case filterType.track:
        tempFilter = {...musicFilter, "searchText" : "", "type" : filterType.text, "searchRef" : "", segment : null, ignore_vocals: false, prioritize_bpm: false};
        break;
      default : 
        tempFilter = {...musicFilter, "searchText" : "", "type" : filterType.text};
        break;
    }
    // console.log("temp filter ; ", tempFilter)
    setMusicFilter(tempFilter);
    CookieManager.setCookie("harmix-music-filter", encodeURIComponent(JSON.stringify(tempFilter)));
    
    //if removing 'track' type filter, URL need to reset    
    if(type === filterType.track)
      history.push('/library')

    setTrackList([]);
    setPageNo(0);
    loadAIMSTrackList(tempFilter, true);
      
  }
  const getSearchText = () => {
    let elem = "";
    switch(musicFilter.type){
      case filterType.text : 
        elem = <div className="rounded-xl w-11/12 lg:w-auto filter-tile-pink text-title px-2 mx-1 pb-1 row-line flex justify-center items-center">
          <img
            src={textFileLogo}
            alt="logo"
            className="h-4 mt-1 mr-1"
            title="text search"
          />
          {/* {musicFilter.searchText} */}
          <div className=" w-11/12 lg:w-auto" title={musicFilter.searchText}>{truncateText(musicFilter.searchText, 50)}</div>
          <CloseModal className="closefilter mt-1.5 ml-3 cursor-pointer" title={"Clear search"} onClick={() => removeSearchFilter(musicFilter.type)} />
        </div>
        break;
      case filterType.youtube : 
        elem = <div className="rounded-xl w-11/12 lg:w-auto filter-tile-red text-title px-2 mx-1 pb-1 row-line flex justify-center items-center">
          <img
            src={youtubeLogo}
            alt="logo"
            className="h-4 mt-0.5 mr-1"
            title="youtube link search"
          />
          {/* {musicFilter.searchText} */}
          <div className=" w-11/12 lg:w-auto" title={musicFilter.searchText}>{truncateText(musicFilter.searchText, 50)}</div>
          <CloseModal className="closefilter mt-1.5 ml-3 cursor-pointer" title={"Clear search"} onClick={() => removeSearchFilter(musicFilter.type)} />
        </div>
        break;
      case filterType.spotify : 
        elem = <div className="rounded-xl w-11/12 lg:w-auto filter-tile-green text-title px-2 mx-1 pb-1 row-line flex justify-center items-center">
          <img
            src={spotifyLogo}
            alt="logo"
            className="h-4 mt-1 mr-1"
            title="spotify link search"
          />
          <div className=" w-11/12 lg:w-auto" title={musicFilter.searchText}>{truncateText(musicFilter.searchText, 50)}</div>
          <CloseModal className="closefilter mt-1.5 ml-3 cursor-pointer" title={"Clear search"} onClick={() => removeSearchFilter(musicFilter.type)} />
        </div>
        break;
      case filterType.audio_file :
      case filterType.video_file : 
        elem = <div className="rounded-xl w-11/12 lg:w-auto filter-tile-blue text-title px-2 mx-1 row-line flex justify-center items-center">
          {/* <img
            src={fileUploadLogo}
            alt="logo"
            className="h-4 mt-1 mr-1"
            title="file reference search"
          /> */}
          <UploadIcon className="pr-1"  height={"28px"} width={"28px"} style={{'marginTop' : "-5px"}}/>
          {/* {musicFilter.searchText} */}
          <div className=" w-11/12 lg:w-auto" title={musicFilter.searchText}>{truncateText(musicFilter.searchText, 50)}</div>
          <CloseModal className="closefilter mt-1.5 ml-3 cursor-pointer" title={"Clear search"} onClick={() => removeSearchFilter(musicFilter.type)} />
        </div>
        break;
      
      case filterType.track : 
        elem = <div className="rounded-xl w-11/12 lg:w-auto filter-tile-gray text-title px-2 mx-1 py-1 row-line flex justify-center items-center">
          {/* <JoinInner className="pr-1" style={{height : "20px", width : "auto"}} /> */}
          <span className="pr-1 self-center">{Helper.getSearchIcon("rgb(var(--text))", 24, 24)}</span>
          {/* {musicFilter.searchText} */}
          <div className=" w-11/12 lg:w-auto" title={musicFilter.searchText}>{truncateText(musicFilter.searchText, 50)}</div>
          <CloseModal className="closefilter mt-1.5 ml-3 cursor-pointer" title={"Clear search"} onClick={() => removeSearchFilter(musicFilter.type)} />
        </div>
        break;

      default : 
      break;
    }

    return (elem)
  }
  const loadFilteredData = async() => {
    const tempFilter = getMusicFilter();
    setMusicFilter(tempFilter);
    await loadAIMSTrackList(tempFilter, true)
  }

   //cancelling file upload
   const cancelUpload=async()=>{
    const source = cancelToken;
    source.cancel(Constants.FILE_UPLOAD_CANCELLED)
    setCancelToken();
    removeSearchFilter("file");
    await HarmixService.executeRequest('','',source).then(async()=> {
      setShowProgress(false);
      await loadFilteredData(getFilterObj());
    })
  }
  
  const setAdditionalFilterData = (key, value) => {
    // console.log("toggled : ", key, value)
    const tempFilter = musicFilter;
    if(key =="ignore_vocals" || key == "prioritize_bpm"){
      tempFilter[key] = value;
    }
    setMusicFilter(tempFilter);
    CookieManager.setCookie("harmix-music-filter", encodeURIComponent(JSON.stringify(tempFilter)));
    
  }

  const getComposers = (compNames) => {
    const tempData = {};
    if(compNames?.length > 0){
      const arr = compNames.split(",");
      arr?.length > 1 && arr.forEach((elem, idx) => {
        tempData[idx] = elem;
      });
      arr?.length === 1 && (() => {tempData["1"] = arr[0]})();
    }
    return tempData;
  }

  
const handleKeySearchClick = async (e) => {
  trackContext.setSearch(true);
}

useEffect(() => {
  if(window.location.pathname.includes("/library")){
    setSelectedSearchType(searchTypes.prompt);
    setMusicFilter(getMusicFilter());
  }else if(window.location.pathname.includes("/music/")){
    setSelectedSearchType(searchTypes.standard);

  }else{
    setSelectedSearchType(searchTypes.standard);
  }
}, [window.location.pathname])

useEffect(()=>{
  // if(!trackContext.validateUser(Constants.ACTION.SEARCH)){
  //   history.push("/");
  //   return;
  // }
  if(selectedSearchType === searchTypes.prompt){
    //redirecting to standerd search if user is not valid for SEARCH action.
    if(!trackContext.validateUser(Constants.ACTION.SEARCH)){
      history.push("/");
      return;
    }
    if(musicFilter?.type === "audio_file"){
      (async() => {
          await loadAudioSearchedData(musicFilter);
        })()
    }else{
      
      (async() => {
        await loadAIMSTrackList(musicFilter, true);
      })()
    }
  }
},[selectedSearchType])

const loadAudioSearchedData = async(musicFilter) => {
  if(!musicFilter || !musicFilter?.searchRef){
    console.log("Missing music filter while audio file upload search reloading");
    return;
  }
  setLoading(true);
  const searchResp = await API.loadSearchedDataUsingUpload({fileName : musicFilter?.searchText, url : musicFilter.searchRef})
    .catch((err) => {
      console.log("Error searching tracks via File Upload : ", err);
      toast(({ closeToast }) => <ErrorToast  message={"Error searching tracks via File Upload. Please try uploading again."}/>);
    })
  // console.log("search resp : ", searchResp);
  if(searchResp?.data?.Tracks?.length > 0){
    setTrackList([...searchResp.data.Tracks]);
  }
  if(!searchResp?.data?.Tracks || searchResp?.data?.Tracks?.length === 0){
    toast(({ closeToast }) => <WarningToast  message={"No tracks found for uploaded track."}/>);
    setAllDataLoaded(true);
    setTrackList([]);
  }
  setLoading(false);
  return;
}   
const standardSearch = () => {
  
  if(searchkey?.length > 0){
    if(trackContext.searchResultView === Constants.SEARCH_RESULT_VIEW_TYPE.albums){
      history.push(`/music/albums/${trackContext.searchkey}`);
    }else{
      history.push(`/music/tracks/${trackContext.searchkey}`);
    }
  }else{
    history.push(`/`);
  }
  setSelectedSearchType(searchTypes.standard);
}

const AISearchClicked = () => {
  if (!trackContext.validateUser(Constants.ACTION.SEARCH)) {
    trackContext.setShowSubscribePopup(true);
    trackContext.setUserAction(Constants.ACTION.SEARCH);
    return;
  }
  // const filter = getMusicFilter();
  // if(filter?.type === "track" && filter?.searchRef?.length > 0){
  //   const refTrackData =CookieManager.getCookie("searched-track-data")?.length > 0 ? JSON.parse(CookieManager.getCookie("searched-track-data")) : null;
  //   if(refTrackData){
  //     history.push(`/library/${filter.searchRef}`, {searchedTrackData : {...refTrackData}});
  //   }else{
  //     console.log("missing track filter data, switching to default search.");
  //     history.push(`/library`);
  //   }
  // }else{
  //   history.push(`/library`);
  // }
  // setSelectedSearchType(searchTypes.prompt);
}

const [isExpanded, setIsExpanded] = useState(true);

const toggleExpand = () => {
  console.log("Toggle clicked, current state:", isExpanded);
  setIsExpanded(prevState => !prevState);
};

useEffect(() => {
  console.log("Expanded state changed to:", isExpanded);
}, [isExpanded]);

const truncateText = (text, maxLength) => {
  if (!text || text === '-') return text;
  return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
};

// Calculate the height to hide (keep only 48px visible)
const playerHeight = isExpanded ? '0' : 'calc(-140px)';

  return (
    <>
      <div className="items-center p-1 rounded-2xl view-box" 
        style={{background: "rgb(var(--bg))", color: "rgb(var(--text))", minHeight: "80vh", maxHeight : "80vh"}}>
        {/* <div className="w-full flex pt-20">
          <div style={{"margin-top": "-4px"}}>
            <AIIcon  height={"50px"} width={"50px"}/>
          </div>
          <div className="rounded-full aisearch border-pink w-full flex flex-wrap ">
            
            <input
              // onFocus={(e) => {handleSearch(e)}}
              // onChange={(e) => {handleSearch(e.target.value)}}
              onChange={event => { setSearchText(event.target.value) }}
              onKeyDown={handleSearch}
              className={`self-center w-11/12 bg-white cursor-pointer placeholder-textGray-600 rounded-full`}
              // type="text"
              placeholder="Enter a prompt. Paste a YouTube/Spotify link. Upload a reference audio track or your video."
              disabled={loading}
              value={searchText}
            />
            <span className="w-1/12 flex justify-end">
              <button onClick={handleUploadClick} disabled={processing || loading} className="justify-end border-0 p-0 mb-0" title="Click to upload an audio file.">
              <UploadIcon  height={"35px"} width={"35px"}/>
              <input type="file" accept=".mp3,.m4a,.wav,.mp4" style={{ display: "none" }} onChange={(e) => uploadAudioFile(e.target.files[0])} ref={hiddenFileInput} /></button>
            </span>
          </div>
        </div> */}
        <div className="w-full">
          {/* <div className="block md:hidden flex button-group m-0.5">
            
            <div
              className="w-full button cursor-pointer text-white px-1"
              onClick={() => AISearchClicked()}
              style={{ 
                backgroundColor: selectedSearchType === searchTypes.prompt ? 'rgb(var(--text))' : 'lightgray',
                color: selectedSearchType === searchTypes.prompt ? 'rgb(var(--bg))' : 'black',
              }}
            >
              AI Search
            </div>
            <div
              className="w-full button cursor-pointer px-1"
              onClick={() => standardSearch()}
              style={{ 
                backgroundColor: selectedSearchType === searchTypes.standard ? 'rgb(var(--text))' : 'lightgray',
                color: selectedSearchType === searchTypes.standard ? 'rgb(var(--bg))' : 'black',
              }}
            >
              Keyword
            </div>
          </div>
          <div className="w-full rounded-2xl flex border-textGray-300 border" style={{background: "rgb(var(--bg))", color: "rgb(var(--text))", boxShadow: "4px 4px 12px rgb(var(--text))"}}>
            <div className="rounded-2xl w-full flex m-1" >     
              {selectedSearchType === searchTypes.prompt ? 
                <div className="w-full flex relative">     
                  <textarea id="prompt_search_box" className="p-2 search-box outline-none border border-textGray-300 text-xs lg:text-base rounded-2xl"
                    onChange={event => { setSearchText(event.target.value) }}
                    onKeyDown={handleSearch}
                    placeholder="Enter a prompt. Search by lyrics. Paste a YouTube/Spotify link. Upload a reference audio track or your video."
                    disabled={loading}
                    value={searchText}
                    name="search_box" 
                    rows="1" 
                    cols="60"
                    style={{"font-size": "13px", "height" : "80px"}} >
                  </textarea>
                  <span className="flex justify-start absolute bottom-1 right-0">
                    <span 
                      onClick={handleUploadClick} 
                      disabled={processing || loading} 
                      className="justify-end cursor-pointer"
                      title="Click to upload an audio/video file."
                    >
                    <UploadFileIcon
                      style={{color: "rgb(var(--secondary))", height:"38px", width:"38px"}}
                    />
                    <input type="file" accept=".mp3,.wav,.aif,.mp4" style={{ display: "none" }} onChange={(e) => uploadAudioFile(e.target.files[0])} ref={hiddenFileInput} />
                    </span>
                  </span>
                </div> :
                <div className="w-full flex">     
                  <textarea id="search_box" className="p-1 search-box rounded-2xl outline-none text-xs lg:text-base text-gray-600"
                    onFocus={e => handleKeySearchClick(e)}
                    placeholder="Search by title or artist"
                    disabled={loading}
                    value={searchkey}
                    name="search_box" rows="1" cols="60" 
                    style={{"font-size": "13px", "height" : "80px"}} />
                </div>
              }
            </div>
            <div className="hidden md:block lg:w-1/12 flex-wrap button-group m-0.5">
              
              <div
                className="w-full button cursor-pointer text-white"
                onClick={() => AISearchClicked()}
                style={{ 
                  backgroundColor: selectedSearchType === searchTypes.prompt ? 'rgb(var(--text))' : 'lightgray',
                  color: selectedSearchType === searchTypes.prompt ? 'rgb(var(--bg))' : 'black',
                }}
              >
                AI Search
              </div>
              <div
                className="w-full button cursor-pointer mt-1"
                onClick={() => standardSearch()}
              style={{ 
                backgroundColor: selectedSearchType === searchTypes.standard ? 'rgb(var(--text))' : 'lightgray',
                color: selectedSearchType === searchTypes.standard ? 'rgb(var(--bg))' : 'black',
              }}
              >
                Keyword
              </div>
            </div>
          </div> */}
          <div className="rounded-2xl w-full" > 
            <div className="w-full flex mb-1">     
              <textarea id="search_box" className=" p-1 pl-2 search-box search-icon rounded-2xl outline-none text-xs lg:text-base text-gray-600"
                onFocus={e => {
                  handleKeySearchClick(e); 
                  // standardSearch();
                }}
                placeholder="Search by title (track or album) or artist name."
                disabled={loading}
                value={trackContext.AISearch ?  "" : searchkey}
                name="search_box" rows="1" cols="60" 
                style={{"font-size": "13px", "height" : "36px"}} />
            </div>
            <div className="w-full flex relative">     
              <textarea id="prompt_search_box" className="p-2 search-box outline-none text-xs lg:text-base rounded-3xl"
                onFocus={e => {AISearchClicked();}}
                onChange={event => { setSearchText(event.target.value) }}
                onKeyDown={handleSearch}
                placeholder={AISearchPlaceholder}
                disabled={loading || (!profileData || !profileData?.email || profileData?.email?.length === 0)}
                value={searchText}
                name="search_box" 
                rows="1" 
                cols="60"
                style={{"font-size": "13px", "height" : "80px", background : `${(!profileData || !profileData?.email || profileData?.email?.length === 0) && "lightgrey"}`}} >
              </textarea>
              <span className="flex justify-start absolute bottom-1 right-0">
                <span 
                  onClick={handleUploadClick} 
                  disabled={processing || loading} 
                  className="justify-end cursor-pointer mx-1"
                  title="Click to upload an audio/video file."
                >
                <UploadDocIcon
                  size={30}
                  color={"rgb(var(--text))"}
                  style={{color: "rgb(var(--text))", height:"38px", width:"38px"}}
                />
                <input 
                  type="file" 
                  accept=".mp3,.wav,.aif" 
                  style={{ display: "none" }} 
                  onChange={(e) => searchAIMSViaFileUpload(e.target.files[0])} 
                  ref={hiddenFileInput} 
                  onClick={() => {loadAIMSAuthToken()}}/>
                </span>
              </span>
            </div>
             
          </div>
        </div>
        {selectedSearchType === searchTypes.prompt ?
          <>
          {musicFilter.type === filterType.track && assetId && searchedTrackData && 
          <>
          <div className="w-full flex flex-wrap mt-1 mx-0" style={{position: "relative"}}>
            <div className=" w-full flex flex-col  gap-y-1" style={{backgroundColor : "#eceef1", display: isExpanded ? "block" : "none"}} >
              <div className="w-full  flex flex-col md:flex-row gap-y-1 md:gap-y-0 "
                style={{ 
                  // backgroundColor: 'rgb(var(--text))',
                  backgroundColor: "#f6f6f6",
                  color:'rgb(var(--header))',
                }}
              >
                <div className="block sm:w-2/6 flex flex-col md:flex-row">
                <div className="w-full py-2 px-4 flex items-center">
                <div className="flex w-full">
                  {/* Album Cover Image */}
                  <div className="flex-shrink-0 mr-4">
                    {searchedTrackData?.albumId ? (
                        <Link className="self-center" to={`/album/${searchedTrackData.albumId}`}>
                          <img
                            src={Helper.getArtworkURL(searchedTrackData.albumId) || defaultImage}
                            alt=""
                            onError={(e) => {     e.target.onerror = null;     e.target.src = defaultImage   }}
                            className="w-full border"
                            loading="lazy"
                            style={{width:"100px"}}
                          />
                        </Link>
                      ) : (
                        <img
                          src={defaultImage}
                          alt="Default album cover"
                          style={{width:"100px"}}
                          className="  shadow-md"
                        />
                      )}
                  </div>
                  
                  {/* Track Information */}
                  <div className="flex flex-col justify-center">
                    <div className="t-title">
                      {searchedTrackData?.title?.toLowerCase()}
                    </div>
                    <div className="t-artist">
                      {searchedTrackData.artist?.toLowerCase()}
                    </div>
                    <div className="t-desc" style={{color : 'rgb(var(--header))'}}>
                      {new Date(searchedTrackData.duration * 1000).toISOString().substr(14, 5)}
                    </div>
                  </div>
                </div>
              </div>
              </div>
              <div className="w-full md:mx-4 justify-end">
                <SegmentSelector trackData={searchedTrackData}/>
              </div>
            </div>
            <div className="w-full flex justify-between items-center mx-1">
              {/* Toggle Switches - Start */}
              <div className="w-1/2 flex flex-col px-4 md:flex-row flex-wrap md:justify-start"  style={{color: "rgb(var(--header))"}}>
                <div className=" flex justify-center md:justify-start">
                  <ToggleSwitch  label={"Prioritize BPM"} id={"prioritize_bpm"} value={musicFilter.prioritize_bpm} setValue={setAdditionalFilterData} />
                </div>
                <div className=" flex justify-center md:justify-start">
                  <ToggleSwitch label={"Ignore Vocals"} id={"ignore_vocals"} value={musicFilter.ignore_vocals} setValue={setAdditionalFilterData} />
                </div>
              </div>
              {/* Search Button - End */}
              <div className="w-1/2 flex  justify-end mt-4 md:mt-0">
                <button className="w-4/6 md:w-auto border-0 " onClick={loadFilteredData}
                  style={{backgroundColor : "black", color : "white"}}>
                  <Search />
                  Search
                </button>
              </div>
            </div>
            </div>
          </div>
          <div className="flex justify-end text-white rounded-t-md cursor-pointer" onClick={toggleExpand}>
          {isExpanded ? (
              <div
                style={{ backgroundColor: "rgb(var(--pink))" }}
                className="px-3 py-1 inline-block"
              >
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="16" 
                  height="16" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="rgb(var(--bg))" 
                  strokeWidth="4" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                  className="text-white"
                >
                  <polyline points="18 15 12 9 6 15"></polyline>
                </svg>
              </div>
            ) : (
              <div
                style={{backgroundColor: "rgb(var(--pink))"}}
                className="px-3 py-1 inline-block"
              >
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="16" 
                  height="16" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="rgb(var(--bg))" 
                  strokeWidth="4" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </div>
            )}
          </div>
          </>}
          {!processing && !loading && musicFilter?.searchText?.length > 0 &&
            <div className="w-full flex flex-wrap my-2" >
              <b>Search results for :</b> {getSearchText()}
            </div>
          }
          <div className="border-t my-2"></div>
          {(showProgress)  && (
          <div>
          <div className="mt-6 flex text-center ">

          </div>
          <div className="progressbar-main">
          <h3 className="progress-header">Your file is {progress}% uploaded, please wait...</h3>
              <div className="progressbar-container">
                <div >
                  <progress className="progressbar" value={progress} max="100" min="0" ></progress>
                </div>
                <div>
                  <button
                  onClick={() => cancelUpload()}
                  className="pt-2 pb-2 pl-4 border-0 cancel-upload pr-4 cancel-btn signin-btn font-bold text-sm mt-3"
                  type="button"
                >Cancel Upload</button>
                </div>
              </div>
          </div>
          </div>
          )}

          <div className="w-full sm:flex sm:flex-wrap  justify-center">
            {!showProgress && processing && 
              <div className="text-xl text-center w-full text-green-500 my-5">
                We are processing your request, please wait...
              </div>
            }
            {!processing && loading &&  
              <div className='w-full'>
                <BouncingLoader />
              </div>
            }
              {/* <React.Fragment > */}
                <video id="video-player" ref={videoRef} controls style={{ marginTop: "20px", width: "100%", display: "none" }} onLoadedMetadata={searchViaVideoUpload}></video>
              {/* </React.Fragment> */}
            {!processing && !loading && !(trackList?.length > 0) ? (
              <div className="text-xl text-center text-red-500 my-5">
                No Tracks Found
              </div>
            ) : 
            (<>
              
              {!processing && trackList?.map((track, index, arr) => (
                  <Track
                    // tags={track.tags}
                    image={Helper.getArtworkURL(track.AlbumID)}
                    key={track.ID}
                    albumId={track.AlbumID}
                    title={track.DisplayTitle || track.Name}
                    duration={track.LengthSeconds}
                    bpm={track.Bpm}
                    versions={track.AlternateCount}
                    producer={track.Publisher}
                    artistName={
                      track.Composer
                    }
                    album={track.AlbumName}
                    trackId={track.ID}
                    waveform={Helper.getWaveformURL(track.ID)}
                    // setTrackUrl={props.setTrackUrl}
                    // setFetchingTrack={trackContext.setFetchingTrack}
                    // changeCurrentTrackImage={props.changeCurrentTrackImage}
                    displayProjectModal={displayProjectModal}
                    // handleCurrentTrackDetail={props.handleCurrentTrackDetail}
                    // similarity={track?.similarity}
                    description={track?.Comment}
                    expandedTrackId={expandedTrackId}
                    setExpandedTrackId={setExpandedTrackId}
                    pageId={pageId}
                    artists={
                      Helper.getComposers(track.Composers)
                    }

                    downloadingTracks = {downloadingTracks}
                    setDownloadingTracks = {setDownloadingTracks}
                    favingTracks = {favingTracks}
                    setFavingTracks = {setFavingTracks}
                    // commandOnChange = {setFilterTrackIds}

                    highlights = {trackHighlightData[track.ID] || []}
                    lyrics = {track.Lyrics || ""}
                    
                  />
                  
              ))}
            </>)
            }
            {selectedSearchType === searchTypes.standard && (
              <div id="load-more-data" ref={loadMoreRef} className="p-2">
                <BouncingLoader />
              </div>
            )}
          </div>
          </> : 
          <>
            <Music />
          </>
        }
      </div>
    {/* {showProjectModal && (
      <AddTrackToProjectPopup
        trackToBeAddedToProject={trackToBeAddedToProject}
        closeProjectModal={closeProjectModal}
      />
    )} */}
    </>
  );
};

export default HarmixMusic;